import {Entity} from '../core/main.entity';

export class Pagination extends Entity {
  page = 0;
  limit = 20;
  total = 0;
}
